import { FC } from 'react';
import List from 'components/segments/components/List';

const Screen: FC = () => {
  return (
    <List
      entityName="segments"
      entityEndpoint="segments"
      displayName="segment"
    />
  );
};

export default Screen;
